import ActivationModeServiceProvider from './container'
export { ActivationModeServiceProvider }
export default ActivationModeServiceProvider